import { render } from "./LigipaasetavusTyhiPaigutusLeht.vue?vue&type=template&id=9aad92c0&ts=true"
import script from "./LigipaasetavusTyhiPaigutusLeht.vue?vue&type=script&lang=ts"
export * from "./LigipaasetavusTyhiPaigutusLeht.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__